module.exports = __webpack_public_path__ + "static/media/28.54ad8608.png";